var map = {
	"./flag-ar_SA.png": 9989,
	"./flag-ca_ES.png": 9204,
	"./flag-de_DE.png": 3501,
	"./flag-en_GB.png": 7410,
	"./flag-es_ES.png": 5691,
	"./flag-fr_FR.png": 8879,
	"./flag-it_IT.png": 5432,
	"./flag-pt_PR.png": 4462,
	"./flag-ru_RU.png": 8481,
	"./flag-zh_CN.png": 7619
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9512;